import { render, staticRenderFns } from "./line.vue?vue&type=template&id=c72c5c14&scoped=true&"
import script from "./line.vue?vue&type=script&lang=js&"
export * from "./line.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c72c5c14",
  null
  
)

export default component.exports